export const restrictedTypes = {
  BANNED: 'banned',
  OFFENSIVE: 'offensive',
  PROTECTED: 'protected'
};

export const ART_SEARCH_CONSTANTS = [
  {prioritized: 'Coronavirus'},
  {prioritized: 'Covid'},
  {prioritized: 'Covid 19'},
  {prioritized: 'Distance'},
  {prioritized: 'Distance Learning'},
  {prioritized: 'Essential'},
  {prioritized: 'Facemask'},
  {prioritized: 'Face Masks'},
  {prioritized: 'Hand Sanitizer'},
  {prioritized: 'Medical Mask'},
  {prioritized: 'Pandemic'},
  {prioritized: 'Quarantine'},
  {prioritized: 'Sanitizer'},
  {prioritized: 'Social Distance'},
  {prioritized: 'Social Distancing'},
  {prioritized: 'Stay At Home'},
  {prioritized: 'Stay Home'},
  {prioritized: 'Stronger Together'},
  {prioritized: 'Surgical Mask'},
  {prioritized: 'Work From Home'},
  {prioritized: 'Wash Your Hands'},
  {prioritized: 'Washing Hands'}
];

export const bannedWords = [
  'cholo',
  'coon',
  'hitler',
  'kkk',
  'nazi',
  'nigga',
  'nigger',
  'ss',
  'swastika'
];

export const offensiveWords = [
  '88',
  'alm',
  'ar15',
  'cocaine',
  'crip',
  'crips',
  'cum',
  'dildo',
  'gadsden',
  'hentai',
  'lsd',
  'm16',
  'meth',
  'pornhub',
  'tits',
  'titties'
];
